//@flow
import React, { Component } from 'react';
import injectSheet from 'react-jss';
import type { Node } from 'react';
import { icons, Typography } from '@hiver/hiver-ui-kit';

class Accordion extends Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: true
        };
    }
    componentWillMount(){
        this.syncState();
    }
    componentWillReceiveProps(nextProps){
        if (nextProps && nextProps.collapsed !== this.props.collapsed)
            this.syncState(nextProps);
    }
    syncState = (nextProps: ?Object) => {
        let { collapsed } = this.props;
        if (nextProps && nextProps.hasOwnProperty('collapsed'))
            collapsed = nextProps.collapsed;
        if (typeof collapsed === 'boolean')
            this.setState({ collapsed });
    }
    toggle = () => this.setState(({ collapsed }) => ({
        collapsed: !collapsed
    }), () => {
        if (typeof this.props.onCollapse  === 'function')
            this.props.onCollapse(this.state.collapsed);
    });
    
    render() {
        const { classes, title, action, children, errorCount} = this.props;
        const { collapsed } = this.state;
        return (
            <div className={classes.root}>
                <div className={classes.header} onClick={this.toggle}
                    style={ collapsed ? {} : {
                        borderRadius: '4px 4px 0px 0px',
                        borderBottom: '1px solid #D6DDE8',
                    }}
                >
                    <div className="h-flexbox--sb-vc">
                        <icons.ChevronRightOutlined
                            sx={{
                                height: "20px",
                                width: "20px",
                                marginRight: "8px",
                                transition: "transform .3s ease",
                                ...(collapsed ? {} : { transform: "rotate(90deg)" })
                            }}
                        />
                        <div className="h-h3">
                            <Typography variant="h3">{ title } </Typography> 
                            {(errorCount > 0) ? 
                                <div className={classes.errorCountPane}>
                                    <span className={classes.errorCount}>
                                        {errorCount}
                                    </span>
                                </div>
                                :""
                            }
                        </div>
                       
                    </div>
                    { action }
                </div>
                { !collapsed && 
                    <div className={classes.body}>
                        { children }
                    </div>
                }
            </div>
        )
    }
}

type Props = {
    classes: Object,
    title: string | Node,
    action: string | Node,
    collapsed: boolean,
    onCollapse: Function,
    children: Node | Array<Node>
}
type State = {
    collapsed: ?boolean
}
const style = {
    root: {
        marginBottom: 20,
        borderRadius: '4px',
        border: '1px solid var(--monotones-gray-5, #D6DDE8)',
        backgroundColor: 'var(--monotones-white, #FFF)',
    },
    header: {
        display: 'flex',
        cursor: 'pointer',
        justifyContent: 'space-between',
        padding: '12px 14px',
        color: '#283e4b',
        position: 'relative',
    },
    body: {
        padding: '25px 14px'
    },
    icon: {
        height: 19,
        width: 19,
    },

    errorCountPane:{
        display: 'inline-flex',  
        verticalAlign: 'top'
    },

    errorCount:{
        height: '15px',
        width: '15px',
        backgroundColor: '#ff9493',
        borderRadius: '50%',
        display: 'inline-block',
        padding: '2px 5px 5px 4.5px',
        boxSizing: 'border-box',
        fontSize: '10px',
        color: '#fff',
        margin: '-7px 0 0 4px'
    }
}
export default injectSheet(style)(Accordion);
